module.exports = __webpack_public_path__ + "static/media/sensor-people.a87609ac.jpg";